module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsSAAALEgHS3X78AAAAuUlEQVQ4jc3Tyw0CIRSF4R9jAZZgCRbAQjuwBRsgTglWoKECO7AENaGA6UBLmA4wNwHjYxgBXXg2PBK+3FyAX0WVOt7oKbAEOmXdPu4XQd7oGXAEJmFrp6xrZDL6ApGs4yQLSiCSNhsaQDpgFReDPfqALJR194qSUAmShEqRXqgGeYNqEXpu7VCDPEHeaEE24WAR8lrRHNgCTQCyEWKPwke8PFQhWJuLSMZhlL6cgHN49oJcc5E/DHAD72JPynIzAk8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/ic_btn_edit.png
// module id = 721
// module chunks = 0